const ChevronRightIcon = ({ className }: { className?: string }) => (
	<svg
		className={className}
		fill='none'
		height='12'
		viewBox='0 0 8 12'
		width='8'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			clip-rule='evenodd'
			d='M1.06636 11.6503C1.31044 11.8943 1.70616 11.8943 1.95024 11.6503L7.15858 6.44192C7.40265 6.19784 7.40265 5.80212 7.15858 5.55804L1.95024 0.349705C1.70616 0.105627 1.31044 0.105627 1.06636 0.349705C0.822281 0.593782 0.822281 0.989511 1.06636 1.23359L5.83275 5.99998L1.06636 10.7664C0.822281 11.0104 0.822281 11.4062 1.06636 11.6503Z'
			fill='currentColor'
			fill-rule='evenodd'
		/>
	</svg>
)

export { ChevronRightIcon }
